import React, { useState } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { emptyString } from '../../../../ressources/functionJS/emptyString';
import { jsDictionaryEquals } from '../../../../ressources/functionJS/jsDictionaryEquals';
import * as glossaire_type_de_graphe from '../../../../ressources/glossaires/glossaire_type_de_graphe';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';

export const convertiUtsToDate = (arrayOfUts) => {
  return arrayOfUts.map((unix) => {
    if (isNaN(unix)) {
      return null;
    }
    let unixToconvert = Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(unix * 1000);
    unixToconvert = unixToconvert.replaceAll('/', '-').replace(',', '');
    const time = unixToconvert.split(' ')[1];
    let splitDate = unixToconvert.split(' ')[0].split('-');
    let date = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0];
    return date + ' ' + time;
  });
};
export const formatTextUniteArray = (valeurs, format) => {
  let calculValeurs = [...formatUniteArray(valeurs, format, true)];
  let res = [];
  let newFormat = format;
  if (format.split('2').length > 1) {
    newFormat = format.split('2')[1];
  }
  // boucle pour convertir chaque valeur dans le format en entrée
  for (let i = 0; i < calculValeurs.length; i++) {
    res.push(formatUnite(calculValeurs[i], format) + ' ' + newFormat);
  }
  return res;
};

export const conversions = {
  // Composés
  'jj:hh:mm:ss': (val) => val / (24 * 60 * 60),
  'hh:mm:ss': (val) => val / (60 * 60),
  'mm:ss': (val) => val / 60,
  'mm2hh:mm': (val) => val / 60,
  'ss2hh:mm:ss': (val) => val / (60 * 60),
  'ss2mm:ss': (val) => val / 60,

  // Simples
  jj: (val) => (val / (24 * 60 * 60)).toFixed(2),
  hh: (val) => (val / (60 * 60)).toFixed(2),
  // "mm": val => (val / 60).toFixed(2), // todo: attention confusion avec millimètre
  ss: (val) => val,

  // Jour vers
  jj2hh: (val) => (val * 24).toFixed(2),
  jj2mm: (val) => (val * 24 * 60).toFixed(2),
  jj2ss: (val) => (val * 24 * 60 * 60).toFixed(2),

  // Heure vers
  hh2jj: (val) => (val / 24).toFixed(2),
  hh2mm: (val) => (val * 60).toFixed(2),
  hh2ss: (val) => (val * 60 * 60).toFixed(2),

  // Minute vers
  mm2jj: (val) => (val / (24 * 60)).toFixed(2),
  mm2hh: (val) => (val / 60).toFixed(2),
  mm2ss: (val) => (val * 60).toFixed(2),

  // Seconde vers
  ss2jj: (val) => (val / (24 * 60 * 60)).toFixed(2),
  ss2hh: (val) => (val / (60 * 60)).toFixed(2),
  ss2mm: (val) => (val / 60).toFixed(2),
};

export const conversionsAffichageTexte = {
  // Composés
  'jj:hh:mm:ss': (val) =>
    `${Math.floor(val / (24 * 60 * 60))}:${Math.floor(
      (val % (24 * 60 * 60)) / (60 * 60)
    )}:${Math.floor((val % (60 * 60)) / 60)}:${val % 60}`,
  'hh:mm:ss': (val) =>
    `${Math.floor(val / (60 * 60))}:${Math.floor((val % (60 * 60)) / 60)}:${
      val % 60
    }`,
  'mm:ss': (val) => `${Math.floor(val / 60)}:${val % 60}`,
  'mm2hh:mm': (val) => `${Math.floor(val / 60)}:${val % 60}`,
  'ss2hh:mm:ss': (val) =>
    `${Math.floor(val / (60 * 60))}:${Math.floor((val % (60 * 60)) / 60)}:${
      val % 60
    }`,
  'ss2mm:ss': (val) => `${Math.floor(val / 60)}:${val % 60}`,

  // Simples
  jj: (val) => (val / (24 * 60 * 60)).toFixed(2),
  hh: (val) => (val / (60 * 60)).toFixed(2),
  // "mm": val => (val / 60).toFixed(2), // todo: attention confusion avec millimètre
  ss: (val) => val,

  // Jour vers
  jj2hh: (val) => (val * 24).toFixed(2),
  jj2mm: (val) => (val * 24 * 60).toFixed(2),
  jj2ss: (val) => (val * 24 * 60 * 60).toFixed(2),

  // Heure vers
  hh2jj: (val) => (val / 24).toFixed(2),
  hh2mm: (val) => (val * 60).toFixed(2),
  hh2ss: (val) => (val * 60 * 60).toFixed(2),

  // Minute vers
  mm2jj: (val) => (val / (24 * 60)).toFixed(2),
  mm2hh: (val) => (val / 60).toFixed(2),
  mm2ss: (val) => (val * 60).toFixed(2),

  // Seconde vers
  ss2jj: (val) => (val / (24 * 60 * 60)).toFixed(2),
  ss2hh: (val) => (val / (60 * 60)).toFixed(2),
  ss2mm: (val) => (val / 60).toFixed(2),
};

export const formatUnite = (valeur, format) => {
  if (
    Number.isInteger(valeur) &&
    conversionsAffichageTexte.hasOwnProperty(format)
  ) {
    return conversionsAffichageTexte[format](valeur);
  } else {
    return valeur;
  }
};

export const formatUniteArray = (valeurs, format, affichageText) => {
  let res = [];

  let formatAxe = format;
  if (typeof format === 'string' && format.includes('2') && affichageText) {
    formatAxe = format.split('2')[0];
  }
  // vérifie si le format est valide
  const isValidFormat = formatAxe in conversions;

  // boucle pour convertir chaque valeur dans le format en entrée
  for (let i = 0; i < valeurs.length; i++) {
    let calculValeur = valeurs[i];
    if (Number.isInteger(calculValeur) && isValidFormat) {
      res.push(conversions[formatAxe](calculValeur));
    } else {
      res.push(calculValeur);
    }
  }
  return res;
};

const GrapheXT = ({
  configuration,
  donnees,
  seuils,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  donneesGraphe,
  dimensionWidth,
  dimensionHeight,
  minimaliste,
}) => {
  // Split state into multiple useState hooks
  const [afficherRangeSlider, setAfficherRangeSlider] = useState(false);
  const [afficherManuelMode, setAfficherManuelMode] = useState(false);
  const [afficherModeBar, setAfficherModeBar] = useState(false);
  const [afficherY2, setAfficherY2] = useState(false);

  const handleRangeSliderToggle = () => {
    setAfficherRangeSlider((prev) => !prev);
  };

  const handleModeBarToggle = () => {
    setAfficherManuelMode(true);
    setAfficherModeBar((prev) => !prev);
  };

  const handleY2Toggle = (have_y2_curves) => {
    if (!have_y2_curves) {
      setAfficherY2((prev) => !prev);
    }
  };

  // Layout and data processing
  let layout = {};
  let data = [];
  let have_y2_curves = false;

  if (configuration !== undefined && donnees !== undefined) {
    // Layout configuration
    layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      barmode: configuration.barmode,
      xaxis: {
        ...configuration.xaxis,
        range:
          configuration.graph_type_id === glossaire_type_de_graphe.graphe_x_t &&
          configuration.xaxis.range !== undefined &&
          configuration.xaxis.range.length > 1 &&
          configuration.xaxis.range[0] !== null &&
          configuration.xaxis.range[1] !== null
            ? convertiUtsToDate(configuration.xaxis.range)
            : configuration.xaxis.range,
        autorange:
          configuration.xaxis.range === undefined ||
          configuration.xaxis.range.length === 0 ||
          configuration.xaxis.range[0] === null ||
          configuration.xaxis.range[1] === null,
        showgrid: configuration.showgrid,
        autoscale: !jsDictionaryEquals(configuration.xaxis.range, [null, null]),
        rangeslider:
          viewobj_json_content === undefined && viewobj_json_content !== null
            ? { visible: afficherRangeSlider }
            : viewobj_json_content !== null &&
              viewobj_json_content.showRangeslider === true
            ? { visible: afficherRangeSlider }
            : undefined,
      },
      yaxis: {
        ...configuration.yaxis,
        showgrid: configuration.showgrid,
        autoscale: !jsDictionaryEquals(configuration.yaxis.range, [null, null]),
      },
      yaxis2: {
        ...configuration.yaxis2,
        showgrid: configuration.showgrid,
        autoscale:
          configuration.yaxis2 !== undefined &&
          !jsDictionaryEquals(configuration.yaxis2.range, [null, null]),
        overlaying: 'y',
        side: 'right',
      },
      ...(viewobj_json_content === undefined || viewobj_json_content === null
        ? {}
        : viewobj_json_content.layout),
    };

    // Process data curves
    for (
      let indSetDonnees = 0;
      indSetDonnees < donnees.length;
      indSetDonnees++
    ) {
      if (donnees[indSetDonnees]['yaxis'] === 'y2') {
        have_y2_curves = true;
      }

      let color_curve = {};
      if (donnees[indSetDonnees]['color'] !== undefined) {
        color_curve = {
          marker: {
            color: donnees[indSetDonnees]['color'],
          },
          line: {
            color: donnees[indSetDonnees]['color'],
          },
        };
      }
      let text = [];
      if (
        Object.keys(conversionsAffichageTexte).indexOf(
          donnees[indSetDonnees].engineering_unit > -1
        )
      ) {
        text = [
          ...formatTextUniteArray(
            donnees[indSetDonnees].y,
            donnees[indSetDonnees].engineering_unit
          ),
        ];
      } else {
        for (
          let indDonnee = 0;
          indDonnee < donnees[indSetDonnees].x.length;
          indDonnee++
        ) {
          // mise en forme du nom : name || sensor_name[prefix || position_in_sensor]
          const name = donnees[indSetDonnees].sensor_name;
          const valeurY =
            (!emptyString(donnees[indSetDonnees].name)
              ? donnees[indSetDonnees].name
              : !emptyString(donnees[indSetDonnees].prefix)
              ? donnees[indSetDonnees].prefix
              : '[' + donnees[indSetDonnees].position_in_sensor + ']') +
            ': ' +
            donnees[indSetDonnees].y[indDonnee] +
            ' ' +
            donnees[indSetDonnees].engineering_unit;
          // const valeurX = layout.xaxis.title+": "+utsToDate(donnees[indSetDonnees].x[indDonnee]);

          // mise en forme de l'info bulle pour chaque donnée
          let infoBulle = [
            name,
            valeurY,
            // valeurX,
          ];
          text.push(infoBulle.join('<br>'));
        }
      }
      //converti l'axe des uts en date format plotly (exemple: "2013-10-04 22:23:00")
      const timeAxis = convertiUtsToDate(donnees[indSetDonnees].x);
      const valeurAxis = formatUniteArray(
        donnees[indSetDonnees].y,
        donnees[indSetDonnees].engineering_unit
      );

      let courbe = {
        ...donnees[indSetDonnees],
        x: timeAxis,
        y: valeurAxis,
        text: text,
        hovertemplate: '%{text}<extra></extra>',
        ...color_curve,
      };

      //affiche le nom du capteur [prefix || num composante] si name ===""
      if (donnees[indSetDonnees].name === '') {
        courbe.name =
          donnees[indSetDonnees].sensor_name +
          '[' +
          (donnees[indSetDonnees].prefix !== ''
            ? donnees[indSetDonnees].prefix
            : donnees[indSetDonnees].position_in_sensor) +
          ']';
      }

      if (donnees[indSetDonnees].type === 'bar') {
        courbe.type = 'bar';
      } else {
        courbe.type = 'scatter';
      }

      //cas où on utilise la bar d'outil pour changer le type d'affichage
      if (afficherManuelMode === true) {
        if (afficherModeBar === true) {
          courbe.type = 'bar';
        } else {
          courbe.type = 'scatter';
        }
      }

      data.push(courbe);
    }

    // Process threshold data
    for (let indSetSeuils = 0; indSetSeuils < seuils.length; indSetSeuils++) {
      //spread des config générales du groupes de seuils sur la liste des seuils
      if (
        seuils[indSetSeuils].show_alarms === undefined ||
        parseInt(seuils[indSetSeuils].show_alarms) === 1
      ) {
        let afficherDansLegende = true;
        for (
          let indSeuil = 0;
          indSeuil < seuils[indSetSeuils].data.length;
          indSeuil++
        ) {
          if (
            !(
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].x, null) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].x, [
                null,
              ]) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].x, [
                null,
                null,
              ]) ||
              jsDictionaryEquals(
                seuils[indSetSeuils].data[indSeuil].x,
                undefined
              ) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].x, '') ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].y, null) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].y, [
                null,
              ]) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].y, [
                null,
                null,
              ]) ||
              jsDictionaryEquals(
                seuils[indSetSeuils].data[indSeuil].y,
                undefined
              ) ||
              jsDictionaryEquals(seuils[indSetSeuils].data[indSeuil].y, '')
            )
          ) {
            let text = [];
            // mise en forme du nom : name || sensor_name[prefix || position_in_sensor]
            const sensorName =
              '[' +
              checkMot('alarme') +
              ']' +
              !emptyString(seuils[indSetSeuils].name)
                ? seuils[indSetSeuils].name
                : seuils[indSetSeuils].sensor_name;
            if (seuils[indSetSeuils].data[indSeuil].y !== undefined) {
              for (
                let indValeur = 0;
                indValeur < seuils[indSetSeuils].data[indSeuil].y.length;
                indValeur++
              ) {
                const seuil =
                  (!emptyString(seuils[indSetSeuils].prefix)
                    ? seuils[indSetSeuils].prefix
                    : '[' + seuils[indSetSeuils].position_in_sensor + ']') +
                  ': ' +
                  seuils[indSetSeuils].data[indSeuil].y[indValeur] +
                  ' ' +
                  seuils[indSetSeuils].engineering_unit;
                // mise en forme de l'info bulle pour chaque donnée
                let infoBulle = [sensorName, seuil];
                text.push(infoBulle.join('<br>'));
              }
            }
            //distribue la configuration générale de la courbe de seuils dans les données
            let courbe = {
              ...seuils[indSetSeuils],
              name: seuils[indSetSeuils].sensor_name,
              ...seuils[indSetSeuils].data[indSeuil],
              x: convertiUtsToDate(seuils[indSetSeuils].data[indSeuil].x),
              y: formatUniteArray(
                seuils[indSetSeuils].data[indSeuil].y,
                seuils[indSetSeuils].data[indSeuil].engineering_unit
              ),
            };
            let linecolor;
            switch (
              courbe.line_color.startsWith('High ') ||
              courbe.line_color.startsWith('Low ')
                ? courbe.line_color.split(' ')[1].toLowerCase()
                : courbe.line_color
            ) {
              case 'black':
                linecolor = 'black';
                break;
              case 'red':
                linecolor = '#f70606';
                break;
              case 'amber':
                linecolor = '#ffa233';
                break;
              case 'blue':
                linecolor = '#3390ff';
                break;
              default:
                linecolor = 'green';
                break;
            }
            data.push({
              ...courbe,
              type: 'scatter',
              line: {
                ...courbe.line,
                color: linecolor,
                dash: 'solid',
              },
              name:
                '[' +
                checkMot('alarme') +
                '] ' +
                seuils[indSetSeuils].sensor_name,
              legendgroup: seuils[indSetSeuils].sensor_name,
              showlegend: afficherDansLegende,
              text: text,
              hovertemplate: '%{text}<extra></extra>',
            });
            afficherDansLegende = false; //affiche que la première légende groupé
          }
        }
      }
    }
  }

  // Handle Y2 axis display
  if (afficherY2 === true && !have_y2_curves) {
    layout['legend'] = {
      x: 1.17,
      xanchor: 'right',
      y: 1,
    };
    layout['yaxis'] = {
      ...layout['yaxis'],
      rangemode: 'tozero',
    };
    layout['yaxis2'] = {
      ...layout['yaxis'],
      title: '',
      titlefont: { color: 'rgb(166,22,63)' },
      tickfont: { color: 'rgb(166,22,63)' },
      overlaying: 'y',
      side: 'right',
      showlegend: false, //todo: hide legende
      gridcolor: 'rgba(166,22,63,0.3)',
      gridwidth: 1,
      zerolinecolor: 'rgba(166,22,63,0.7)',
      zerolinewidth: 2,
      hovermode: false,
    };
    let seuils_list = [];
    for (let seuilGroup of seuils) {
      //récupère la liste des seuils pour trouver les extremums
      for (let seuil_couleur of seuilGroup.data) {
        seuils_list.push(...seuil_couleur.y);
      }
    }
    data.push({
      //todo: hide text bulle
      x: [
        data[0].x[parseInt(data[0].x.length / 2)],
        data[0].x[parseInt(data[0].x.length / 2) + 1],
      ],
      y: [
        Math.min(...data[0].y, ...seuils_list),
        Math.max(...data[0].y, ...seuils_list),
      ],
      name: '',
      showlegend: false,
      yaxis: 'y2',
      type: data[0].type,
      mode: 'none',
      hoverinfo: 'none',
      opacity: 0,
    });
  }
  //booleen pour trier la légende dans l'ordre alphabétique
  const sensor_name_sort = false;
  return (
    <BibliothequePlotly
      sensor_name_sort={sensor_name_sort}
      data={data}
      layout={layout}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      donneesGraphe={donneesGraphe}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      minimaliste={minimaliste}
      viewobj_json_content={viewobj_json_content}
      afficherRangeSlider={handleRangeSliderToggle}
      afficherModeBar={handleModeBarToggle}
      afficherY2={have_y2_curves ? null : () => handleY2Toggle(have_y2_curves)}
      modeBar={afficherModeBar}
    />
  );
};

export default GrapheXT;
